import { Action } from '@ngrx/store';
import { CallHistoryCall, CallHistorySearchParams } from './call-history-params.interface';

export const GET_CALL_HISTORY = 'GET_CALL_HISTORY';
export const GET_CALL_HISTORY_SUCCESS = 'GET_CALL_HISTORY_SUCCESS';
export const GET_CALL_HISTORY_FAILURE = 'GET_CALL_HISTORY_FAILURE';
export const SET_CALL_HISTORY_PARAMS = 'SET_CALL_HISTORY_PARAMS';

export class GetCallHistoryAction implements Action {
  readonly type = GET_CALL_HISTORY;

  constructor(public payload: CallHistorySearchParams) {}
}

export class GetCallHistorySuccessAction implements Action {
  readonly type = GET_CALL_HISTORY_SUCCESS;

  constructor(public payload: { data: CallHistoryCall[]; total: number }) {}
}

export class GetCallHistoryFailureAction implements Action {
  readonly type = GET_CALL_HISTORY_FAILURE;

  constructor(public payload: any) {}
}

export class SetCallHistoryParamsAction implements Action {
  readonly type = SET_CALL_HISTORY_PARAMS;

  constructor(public payload: CallHistorySearchParams) {}
}

export type CallHistoryActions =
  | GetCallHistoryAction
  | GetCallHistorySuccessAction
  | GetCallHistoryFailureAction
  | SetCallHistoryParamsAction;
